/* istanbul ignore file */
import React from 'react';
import { EnumDropdown } from 'framework/form';
import { VACANCY_QUESTION_TYPES } from 'domain/recruiting/vacancy/publication/shared/vacancyPublicationService';

const VacancyQuestionTypeInput = ({ source, label }: { source: string; label: string }) => {
  return <EnumDropdown options={VACANCY_QUESTION_TYPES} source={source} label={label} placeholder="Select..." />;
};

export default VacancyQuestionTypeInput;
